"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { usePathname } from "next/navigation";
import type { NavLink } from "@/lib/types/landing";
import Image from "next/image";
import { useState } from "react";
import { LanguageSelector } from "../ui/LanguageSelector";
interface HeaderProps {
  /** Nome da marca exibido no header */
  brandName: string;
  /** Links de navegação */
  links: NavLink[];
  /** Idioma atual */
  lang: string;
}

/**
 * Header da landing com logo e navegação.
 * Adaptado para mobile com menu hamburger.
 */
export function Header(t0) {
  const $ = _c(38);
  const {
    brandName,
    links,
    lang
  } = t0;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const pathname = usePathname();
  const isHomePage = pathname === `/${lang}`;
  const t1 = `/${lang}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative h-10 w-auto"><Image src="/images/logo.png" alt="" width={100} height={56} className="h-full w-auto object-contain" /></div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== brandName) {
    t3 = <span className="text-black">{brandName}</span>;
    $[1] = brandName;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t3) {
    t4 = <Link href={t1} className="flex items-center gap-2 text-lg font-black italic uppercase text-zinc-900 transition hover:text-zinc-600">{t2}{t3}</Link>;
    $[3] = t1;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isHomePage || $[7] !== links) {
    t5 = isHomePage && <ul className="flex items-center gap-8">{links.map(_temp)}</ul>;
    $[6] = isHomePage;
    $[7] = links;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="pl-8 border-l border-zinc-200"><LanguageSelector /></div>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <div className="hidden md:flex items-center gap-8">{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isMenuOpen) {
    t8 = () => setIsMenuOpen(!isMenuOpen);
    $[12] = isMenuOpen;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t10;
  let t9;
  if ($[14] !== isMenuOpen) {
    t9 = isMenuOpen ? <path d="M18 6 6 18M6 6l12 12" /> : <line x1="4" x2="20" y1="12" y2="12" />;
    t10 = !isMenuOpen && <line x1="4" x2="20" y1="6" y2="6" />;
    $[14] = isMenuOpen;
    $[15] = t10;
    $[16] = t9;
  } else {
    t10 = $[15];
    t9 = $[16];
  }
  let t11;
  if ($[17] !== isMenuOpen) {
    t11 = !isMenuOpen && <line x1="4" x2="20" y1="18" y2="18" />;
    $[17] = isMenuOpen;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11 || $[21] !== t9) {
    t12 = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{t9}{t10}{t11}</svg>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== isMenuOpen || $[24] !== t12 || $[25] !== t8) {
    t13 = <button className="flex md:hidden items-center justify-center w-10 h-10 rounded-lg bg-violet-600 text-white transition hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2" onClick={t8} aria-label="Toggle menu" aria-expanded={isMenuOpen}>{t12}</button>;
    $[23] = isMenuOpen;
    $[24] = t12;
    $[25] = t8;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t4 || $[29] !== t7) {
    t14 = <nav className="mx-auto flex max-w-6xl items-center justify-between px-6" aria-label="Main navigation">{t4}{t7}{t13}</nav>;
    $[27] = t13;
    $[28] = t4;
    $[29] = t7;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== isHomePage || $[32] !== isMenuOpen || $[33] !== links) {
    t15 = isMenuOpen && <div className="md:hidden border-t border-zinc-100 bg-white px-6 py-4 shadow-lg absolute w-full left-0 top-full"><ul className="flex flex-col gap-4">{isHomePage && links.map(link_0 => <li key={link_0.href}><Link href={link_0.href} className="block text-lg font-medium text-zinc-600 transition hover:text-violet-600" onClick={() => setIsMenuOpen(false)}>{link_0.label}</Link></li>)}<li className={isHomePage ? "pt-4 border-t border-zinc-100" : ""}><div className="flex items-center justify-between"><span className="text-sm font-medium text-zinc-700">Idioma</span><LanguageSelector /></div></li></ul></div>;
    $[31] = isHomePage;
    $[32] = isMenuOpen;
    $[33] = links;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t14 || $[36] !== t15) {
    t16 = <header className="sticky bg-white top-0 md:top-8 z-50 py-4" role="banner">{t14}{t15}</header>;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
}
function _temp(link) {
  return <li key={link.href}><Link href={link.href} className="font-medium text-zinc-700 transition hover:text-primary">{link.label}</Link></li>;
}